var $ = require('jquery');
var common = require('./common');
require('jquery.cookie');

var self = {};

self.initialise = function($content) {
  $(document).ready(function() {
    var $cookiePanel = $('.cookie-panel'),
      $cookieClose = $('.cookie-close', $cookiePanel),
      $countryMarkers = $('.country-marker'),
      $countryPopups = $('.country-popup'),
      $closePopup = $('.country-popup .close-pop'),
      activePopup = 0,
      windowWidth = 0,
      $header = $('header'),
      $mainNav = $('.main-navigation'),
      $responsiveNav = $('.responsive-nav'),
      $mainNav2 = $('.js-main-nav'),
      $pageNav = $('.page-navigation'),
      $country = $('header .country'),
      $countryBtn = $('.country-select'),
      $account = $('header .account'),
      $mapOverlay = $('.map-overlay'),
      $infoBar = $('.info-bar'),
      innerWidth = common.innerWidth();

    // Cookie bar - yummy
    $cookieClose.click(function(e) {
      e.preventDefault();
      $.cookie('cookie-policy', true, { path: '/' });
      $cookiePanel.hide();
    });

    var cookie = $.cookie('cookie-policy');
    if (cookie === undefined) {
      $cookiePanel.show();
    }

    $('header .header-contents').hide();
    //setTimeout(function () {
    $('.grey-bar').addClass('animate');
    $('header .header-contents').slideDown('slow');
    //}, 600);

    positionPageNavigation();


    $responsiveNav.click(function() {
      $mainNav2.toggleClass('is-active');
    });

    $(window).scroll(function() {
      var $header = $('header'),
        scroll = $(window).scrollTop(),
        $topBanner = $('.outer-div-indent');

      if (scroll >= 90) {
        $header.addClass('animate-header');
        if ($pageNav.length > 0) {
          $pageNav.addClass('animate-page-nav');
        }
      } else {
        $header.removeClass('animate-header');
        if ($pageNav.length > 0) {
          $pageNav.removeClass('animate-page-nav');
        }
      }
      positionPageNavigation();
    });

    // Map dropdown
    function mapController(el, btn) {
      var $btn = $(btn);
      $btn.click(function(e) {
        e.preventDefault();
        // if opening map first scroll to the top of the page
        if ($btn.hasClass('active') === false) {
          $('body').animate({ scrollTop: 0 }, 500, function() {
            $(el).slideToggle();
            $btn.toggleClass('active');
            setTimeout(function() {
              positionMarkers(false);
            }, 500);
          });
        } else {
          $(el).slideToggle();
          $btn.toggleClass('active');
          positionMarkers(true);
        }
      });
    }

    function positionPageNavigation() {
      var pageNavigation = $('.page-navigation-panel');
      if (pageNavigation.length > 0) {
        if (matchMedia('(min-width: 769px)').matches) {
          pageNavigation.css({ top: $infoBar.outerHeight() + $header.outerHeight() });
          return;
        }

        if (matchMedia('(min-width: 581px)').matches) {
          if ($('header.animate-header').length > 0) {
            pageNavigation.css({ top: $infoBar.outerHeight() });
          } else {
            pageNavigation.css({ top: $infoBar.outerHeight() + $header.outerHeight() });
          }
          return;
        }

        if ($('header.animate-header').length > 0) {
          pageNavigation.css({ top: $infoBar.outerHeight() });
        } else {
          pageNavigation.css({ top: $infoBar.outerHeight() + $header.outerHeight() });
        }
      }
    }

    function positionMarkers(hideMarkers) {
      if (hideMarkers === true) {
        $countryMarkers.hide();
      } else {
        $countryMarkers.each(function() {
          var $this = $(this);
          var mapPos = $this.attr('data-coords');

          if (mapPos !== null) {
            var coords = correctMarkerPosition(mapPos);
            $this.css({ top: parseInt(coords[1]), left: parseInt(coords[0]) });
            $this.fadeIn();
          }
        });
      }
    }

    function correctMarkerPosition(mapPos) {
      // default map dimensions
      var baseWidth = 1060;
      var baseHeight = 691;

      // marker coordinates
      var coords = mapPos.split(',');
      var x = parseInt(coords[0]);
      var y = parseInt(coords[1]);

      // correct default position
      x += 5;
      y -= 10;

      // get actual width of map
      var mapImageWidth = $('#world-map').width();

      // calculate difference from base width
      var percentageOfDefault = baseWidth / mapImageWidth;

      // calculate new coords
      x = parseInt(x / percentageOfDefault);
      y = parseInt(y / percentageOfDefault);

      coords[0] = x;
      coords[1] = y;

      return coords;
    }

    function showCountryPopup($this) {
      var countryId = parseInt($this.attr('data-id'));

      if (activePopup != countryId) {
        $countryPopups.hide();
        var $selectPopup = $('.country-popup[data-id=' + countryId + ']');

        var left = parseInt($this.css('left')) - 42;
        var top = parseInt($this.css('top'));

        var dimensions = getDimensionOfHiddenElement($selectPopup); // array 0 = width, 1 = height

        // if popup height grate than space above more display below
        if (top < dimensions[1]) {
          top += 22;

          $selectPopup.removeClass('above');
          $selectPopup.addClass('below');
        } else {
          top = top - dimensions[1] - 2;

          $selectPopup.removeClass('below');
          $selectPopup.addClass('above');
        }

        console.log('top: ' + top);

        $selectPopup.css({ top: top, left: left });
        $selectPopup.fadeIn();
        activePopup = countryId;
      }
    }

    function getDimensionOfHiddenElement($el) {
      var dimensions = [];

      var previousCss = $el.attr('style');

      $el.css({
        position: 'absolute',
        visibility: 'hidden',
        display: 'block',
      });

      dimensions[0] = $el.outerWidth();
      dimensions[1] = $el.outerHeight();

      console.log('width: ' + dimensions[0]);
      console.log('height: ' + dimensions[1]);

      $el.attr('style', previousCss ? previousCss : '');

      return dimensions;
    }

    mapController('.map-overlay', '.country-select, .show-map');

    $countryMarkers.on('click hover', function() {
      showCountryPopup($(this));
    });

    $closePopup.click(function() {
      $countryPopups.fadeOut();
      activePopup = 0;
    });

    // Navigation
    // function navigation() {
    //   if (windowWidth != innerWidth) {
    //     if (innerWidth <= 1024 && (windowWidth === 0 || windowWidth > 1024)) {
    //       var $mainNavClone = $('<nav class="main-navigation" />')
    //         .css({ position: 'relative', 'z-index': '12' })
    //         .insertAfter($header);

    //       // Get or create additional <ul> for mobile only.
    //       var $mainNavMobile = $(
    //         '<ul class="main-navigation__inner main-navigation__inner--mobile" />'
    //       );
    //       $mainNavClone.append($mainNavMobile);

    //       // Get all menu items from the primary and secondary navigation.
    //       var $mainNavPrimaryItems = $('.main-navigation__inner--primary li', $mainNav);
    //       var $mainNavSecondaryItems = $('.main-navigation__inner--secondary li', $mainNav);

    //       var mainNavItems = $('.main-navigation li');

    //       // Add menu items to mobile navigation.
    //       $mainNavMobile.append($mainNavSecondaryItems.clone());
    //       $mainNavMobile.append($mainNavPrimaryItems.clone());

    //       $mainNavMobile.append(mainNavItems.clone());

    //       if ($country.length > 0) {
    //         $mainNavMobile.append(
    //           '<li class="mobile-country">' +
    //             $country.html().replace('responsive-nav', 'hidden') +
    //             '</li>'
    //         );
    //       }
    //       $countryBtn.hide();

    //       if ($account.length > 0 && $mainNavMobile.html().indexOf('get-quote') <= 0) {
    //         $mainNavMobile.append('<li>' + $account.html() + '</li>');
    //       }

    //       $('.mobile-country .country-select').click(function() {
    //         $mapOverlay.slideToggle('slow');

    //         var top = $(this).offset().top + $(this).height() + 30;
    //         $mapOverlay.css({
    //           top: top,
    //           width: '80%',
    //         });
    //       });

    //       $responsiveNav.unbind();

    //       /* Nav closes when resized - Check to ensure it has the correct icon */
    //       if ($mainNavMobile.hasClass('open')) {
    //         $responsiveNav.addClass('active');
    //       } else {
    //         $responsiveNav.removeClass('active');
    //       }

    //       $responsiveNav.click(function(e) {
    //         if ($mainNavMobile.hasClass('open')) {
    //           $mainNavMobile.animate({ left: '-80%' }, 'slow');
    //           $mainNavMobile.removeClass('open');
    //           $responsiveNav.removeClass('active');
    //           $mapOverlay.hide();
    //         } else {
    //           $mainNavMobile.animate({ left: '0' }, 'slow');
    //           $mainNavMobile.addClass('open');
    //           $responsiveNav.addClass('active');
    //         }
    //       });

    //       subNavigation(true);

    //       $('.get-quote').removeClass('btn--light button2 button2--ujarak');
    //     } else if (innerWidth > 768 && (windowWidth === 0 || windowWidth <= 768)) {
    //       $('.get-quote').addClass('btn--light button2 button2--ujarak');

    //       $('.main-navigation')
    //         .not($mainNav)
    //         .remove();
    //       $countryBtn.show();
    //       $('.mobile-country').remove();

    //       $mapOverlay.hide();
    //       $mapOverlay.css({
    //         top: 'auto',
    //         width: 'auto',
    //       });

    //       subNavigation(false);
    //     }
    //     windowWidth = innerWidth;
    //   }
    // }
    // navigation();

    // sub menu drop down
    function subNavigation(mobile) {
      $('.main-navigation ul li').unbind();
      if (mobile === false) {
        $('.main-navigation ul li').hover(
          function(e) {
            $(this)
              .children('ul')
              .hide();
            $(this)
              .children('ul')
              .slideDown('slow');
          },
          function(e) {
            $('ul', this).slideUp('slow');
          }
        );
      } else {
        // reset sub nav
        $('.main-navigation ul li a').removeClass('sub-open');
        $('.main-navigation ul li ul').hide();

        $('.main-navigation ul li a').click(function(e) {
          if ($(this).hasClass('sub-open') === true || $(this).next('ul').length === 0) {
            // allow redirect
          } else {
            e.preventDefault();
            $mapOverlay.slideUp();
            $(this)
              .next('ul')
              .slideDown('slow');
            $(this).addClass('sub-open');
          }
        });
      }
    }

    // Window resize functions
    $(window).resize(function() {
      innerWidth = common.innerWidth();

      // reset marker positions
      if ($countryMarkers.first().show()) {
        positionMarkers(false);
      }
      $countryPopups.hide();
      activePopup = 0;

      // navigation();
      positionPageNavigation();
    });
  });
};

module.exports = self;



// WEBPACK FOOTER //
// ./sitefiles/scripts/global/modules/headerLoad.js